import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const EventList = () => {
    const { school_slug } = useParams();

    const [loading, setLoading] = useState(true);
    const [EventList, setEventList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const [modalData, setModalData] = useState({
        id: null,
        event_front_content: "",
        event_name: "",
        event_content: "",
        event_date: "",
        event_files: [],          // multiple images
        event_previews: [],       // previews
        old_images: [],           // for edit
    });

    const [AchiverImages, setAchiverImages] = useState([]);

    /* ---------------- FETCH DATA ---------------- */
    useEffect(() => {
        fetchEvents();
    }, [school_slug]);

    const fetchEvents = async () => {
        setLoading(true);
        try {
            const res = await axios.get(
                `${baseAPIUrl}admin/life_at_tigps/get_events/${school_slug}`,
                { withCredentials: true }
            );

            if (res.data.status === 1 && res.data.data) {
                console.log(res.data);
                setEventList(res.data.data || []);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    /* ---------------- Handler --------------- */

    const handleEdit = (item) => {
        setIsEdit(true);
        setModalData({
            id: item.id,
            event_front_content: item.event_front_content,
            event_name: item.event_name,
            event_content: item.event_content,
            event_date: item.event_date,
            event_files: [],
            event_previews: Array.isArray(item.images)
                ? item.images.map(img => ({
                    id: img.id, // image table id
                    url: `${baseAPIUrl}assets/images/events/${img.image_name}`
                }))
                : [],
            old_images: Array.isArray(item.images) ? item.images : [],
        });
        setShowModal(true);
    };

    const handleEventImagesChange = (e) => {
        const files = Array.from(e.target.files);

        setModalData(prev => ({
            ...prev,
            event_files: files,
        }));
    };


    const handleDelete = async (id) => {
        if (!window.confirm("Delete this event?")) return;

        const formData = new FormData();
        formData.append("id", id);

        try {
            const res = await axios.post(
                `${baseAPIUrl}admin/life_at_tigps/delete_event`,
                formData,
                { withCredentials: true }
            );

            if (res.data.status === 1) {
                setEventList(prev => prev.filter(e => e.id !== id));
            }
        } catch (err) {
            console.error(err);
            alert("Delete failed");
        }
    };

    const handleDeleteSingleImage = async (imageId) => {
        if (!window.confirm("Remove this image?")) return;

        const formData = new FormData();
        formData.append("image_id", imageId);

        try {
            const res = await axios.post(
                `${baseAPIUrl}admin/life_at_tigps/delete_event_image`,
                formData,
                { withCredentials: true }
            );

            if (res.data.status === 1) {
                // remove image from UI instantly
                setModalData(prev => ({
                    ...prev,
                    event_previews: prev.event_previews.filter(img => img.id !== imageId)
                }));
            } else {
                alert(res.data.message || "Failed to remove image");
            }
        } catch (err) {
            console.error(err);
            alert("Failed to remove image");
        }
    };



    const handleSave = async () => {
        const formData = new FormData();

        formData.append("school_slug", school_slug);
        formData.append("event_front_content", modalData.event_front_content);
        formData.append("event_name", modalData.event_name);
        formData.append("event_content", modalData.event_content);
        formData.append("event_date", modalData.event_date);

        modalData.event_files.forEach(file => {
            formData.append("event_images[]", file);
        });

        if (isEdit) {
            formData.append("id", modalData.id);
            formData.append("old_images", JSON.stringify(modalData.old_images));
        }

        try {
            const url = isEdit
                ? `${baseAPIUrl}admin/life_at_tigps/update_event`
                : `${baseAPIUrl}admin/life_at_tigps/add_event`;

            await axios.post(url, formData, {
                withCredentials: true,
                headers: { "Content-Type": "multipart/form-data" },
            });

            setShowModal(false);
            fetchEvents(); // reload table
        } catch (err) {
            console.error(err);
            alert("Failed to save Event");
        }
    };



    /* ---------------- Submit ---------------- */


    if (loading) return <p>Loading...</p>;
    return (
        <div className="content-wrapper">
            {/* Content Header (Page header) */}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-dark">Event list</h1>
                        </div>{/* /.col */}
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/admin/dashboard">Dashboard</a></li>
                                <li class="breadcrumb-item active">Life at TIGPS</li>
                                <li class="breadcrumb-item active">Event list</li>
                            </ol>
                        </div>{/* /.col */}
                    </div>{/* /.row */}
                </div>{/* /.container-fluid */}
            </div>
            {/* /.content-header */}
            {/* Main content */}
            <section className="content">
                <div className="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                {/*-- /.card-header --*/}
                                <div class="card-header">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h4>Event list</h4>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            <button className="btn btn-primary" onClick={() => {
                                                setIsEdit(false);
                                                setModalData({
                                                    id: null,
                                                    achiver_name: "",
                                                    achiver_content: "",
                                                    achiver_file: null,
                                                    achiver_preview: null,
                                                    old_achiver: null,
                                                });
                                                setShowModal(true);
                                            }}>Add event</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body table-responsive p-0">
                                    <table className="table table-hover text-nowrap">
                                        <thead className="thead-light">
                                            <tr>
                                                <th>#</th>
                                                <th>Event</th>
                                                <th>Date</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {EventList.length > 0 ? (
                                                EventList.map((item, index) => (
                                                    <tr key={item.id}>
                                                        <td>{index + 1}</td>
                                                        <td><strong>{item.event_name}</strong>
                                                            <br />
                                                            <small>{item.event_front_content}</small>
                                                        </td>
                                                        <td>{item.event_date}</td>
                                                        <td>
                                                            <button
                                                                className="btn btn-sm btn-info mr-2"
                                                                onClick={() => handleEdit(item)}
                                                            >
                                                                <i className="fas fa-edit" />
                                                            </button>
                                                            <button
                                                                className="btn btn-sm btn-danger"
                                                                onClick={() => handleDelete(item.id)}
                                                            >
                                                                <i className="fas fa-trash" />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="4" className="text-center">
                                                        No events found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {showModal && (
                <div
                    className="modal fade show"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "rgba(0,0,0,0.5)",
                        position: "fixed",
                        inset: 0,
                        zIndex: 1050,
                    }}
                >
                    <div className="modal-dialog modal-lg modal-dialog-centered" style={{ maxWidth: "900px", width: "100%" }}>
                        <div className="modal-content" style={{ maxWidth: "900px", width: "100%" }}>
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    {isEdit ? "Edit Event" : "Add Event"}
                                </h5>
                                <button
                                    type="button"
                                    className="close"
                                    onClick={() => setShowModal(false)}
                                >
                                    <span>&times;</span>
                                </button>
                            </div>

                            <div className="modal-body" style={{
                                maxHeight: "65vh",
                                overflowY: "auto",
                            }}>

                                {/* Image Content */}
                                <div className="form-group">
                                    <label>Event Front Content</label>
                                    <textarea
                                        className="form-control"
                                        rows="3"
                                        value={modalData.event_front_content}
                                        placeholder="Front page content"
                                        onChange={(e) =>
                                            setModalData({ ...modalData, event_front_content: e.target.value })
                                        }
                                    ></textarea>
                                </div>

                                <div className="form-group">
                                    <label>Event Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={modalData.event_name}
                                        placeholder="Event name"
                                        onChange={e => setModalData({ ...modalData, event_name: e.target.value })}
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Event Content</label>
                                    <textarea
                                        className="form-control"
                                        rows="4"
                                        value={modalData.event_content}
                                        placeholder="Event content"
                                        onChange={e => setModalData({ ...modalData, event_content: e.target.value })}
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Event Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={modalData.event_date}
                                        onChange={e => setModalData({ ...modalData, event_date: e.target.value })}
                                    />
                                </div>

                                {/* Image Upload */}
                                <div className="form-group">
                                    <label>Event Images</label>
                                    <input
                                        type="file"
                                        multiple
                                        className="form-control"
                                        accept="image/*"
                                        onChange={handleEventImagesChange}
                                    />
                                </div>

                                {/* Preview */}
                                <div className="d-flex flex-wrap mt-2">
                                    {Array.isArray(modalData.event_previews) &&
                                        modalData.event_previews.map((img, i) => (
                                            <div className="mt-3">
                                                <div
                                                    key={img.id}
                                                    style={{
                                                        width: "100px",
                                                        marginRight: "12px",
                                                        marginBottom: "16px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    {/* Image */}
                                                    <img
                                                        src={img.url}
                                                        alt="Event"
                                                        style={{
                                                            width: "100%",
                                                            height: "70px",
                                                            objectFit: "cover",
                                                            borderRadius: "6px",
                                                            border: "1px solid #ddd",
                                                        }}
                                                    />

                                                    {/* Remove Button */}
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-danger mt-2"
                                                        style={{ width: "100%" }}
                                                        onClick={() => handleDeleteSingleImage(img.id)}
                                                    >
                                                        <i className="fas fa-minus-circle mr-1"></i>
                                                        Remove
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setShowModal(false)}
                                >
                                    Cancel
                                </button>
                                <button className="btn btn-success" onClick={handleSave}>
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div >
    )
}
export default EventList;